import Vue from 'vue';
import options from './index.vue';
Vue.component('tg-countdown', options);
